import { ReactElement, useEffect, useRef, useState } from 'react';
import { Upload } from 'antd';
import './index.css'
import { getLocalAccessToken } from '../../../../service';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import LoadingBig from '../../../../assets/images/lottie/loading.json';
import { ReactComponent as Image } from '../../../../assets/images/icon/img.svg';
import { ReactComponent as CircleCloseV2 } from '../../../../assets/images/icon/circle-closeV2.svg';
import Lottie from 'lottie-react';
import { UploadListType } from 'antd/es/upload/interface';

interface IProps {
    setUploadedUrls: Function
    isDisabled?: boolean
    imageUrlList?: Array<string>
    listType?: UploadListType
    styles?: { uploadSelect?: React.CSSProperties }
}

const ImageUploader = ({ setUploadedUrls, isDisabled, imageUrlList, listType, styles }: IProps) => {
    const [fileList, setFileList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        setFileList(curr => [info.file, ...curr.filter(q => q.uid !== info.file.uid)]);
        setUploadedUrls((curr: string[]) => info.file.status === 'done' ? [info.file.response, ...curr] : curr);
        const isUploading = info.fileList.some((file) => file.status === 'uploading');
        setLoading(isUploading);
    };

    const onClickRemove = (uploadFile: UploadFile) => {
        setUploadedUrls((curr: string[]) => curr.filter(q => q !== uploadFile.response))
        setFileList(curr => curr.filter(q => q.uid !== uploadFile.uid))
    }

    const itemRender = (originNode: ReactElement, uploadFile: UploadFile, uploadFileList: UploadFile[], actions: { download: Function, preview: Function, remove: Function }) => {
        return loading && uploadFileList?.[0]?.uid === uploadFile.uid
            ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 80, height: 80, borderRadius: 4, backgroundColor: 'var(--secondarys100)', border: '1px solid #0000000D' }}>
                <Lottie
                    style={{ width: 24, height: 24 }}
                    animationData={LoadingBig}
                    autoplay={true}
                />
            </div>
            : <div style={{ position: 'relative', width: 82, height: 82, marginLeft: uploadFileList?.[0]?.uid === uploadFile.uid && (isDisabled || fileList.length >= 5) ? 20 : 0 }}>
                <CircleCloseV2 style={{ position: 'absolute', top: 4, right: 4 }} width={16} height={16} onClick={() => onClickRemove(uploadFile)} />
                <img width={78} height={78} style={{ borderRadius: 4, border: '1px solid #0000000D' }} src={uploadFile.response} />
            </div>
    }

    useEffect(() => {
        if (imageUrlList) {
            const initialFileList = imageUrlList.map((url, index) => ({
                uid: `${index}`,
                name: `Image-${index + 1}`,
                status: 'done',
                url,
                response: url,
            }));
            setFileList(initialFileList);
        }
    }, [imageUrlList])

    return <>
        <div ref={containerRef}>
            <Upload
                disabled={isDisabled}
                action={`${process.env.REACT_APP_API_DOMAIN}/s3/upload/web`}
                headers={{ "Authorization": `Bearer ${getLocalAccessToken()}` }}
                withCredentials={true}
                name='multipartFile'
                listType={listType ? listType : "picture-card"}
                fileList={fileList}
                onChange={handleChange}
                className={"small-upload-card custom-upload-img-container" + (fileList.length > 0 ? ' has-file' : '')}
                multiple
                itemRender={itemRender}
            >
                {!isDisabled && fileList.length < 5 &&
                    <div style={{ marginRight: 8, ...styles?.uploadSelect }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 78, height: 78, borderRadius: 4, backgroundColor: 'var(--secondarys100)', border: '1px solid #0000000D', textAlign: 'center' }}>
                            <div>
                                <Image width={24} height={24} stroke='var(--secondarys400)' style={{ display: 'block', marginBottom: 4 }} />
                                <div className='caption/c1 secondary/s500'>{fileList.length}/5</div>
                            </div>
                        </div>
                    </div>}
            </Upload>
        </div>
    </>
};

export default ImageUploader;
